// eslint-disable-next-line import/no-named-as-default
import api from './base.service';

export const getAll = () => {
  return api().get('/api/student-mentors');
};

export const getByStudentId = (id) => {
  return api().get(`/api/student-mentors/student/${id}`);
};

export const saveUserOjtiList = (payload) => {
  return api().post('/api/student-mentors/all', payload);
};

export const getFreeSubstituteMentors = (studentId, dateFrom, dateTo) => {
  return api().get(`/api/student-mentors/free-ojti?studentId=${studentId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
};

export const getAllOjtiByAtcu = (atcu) => {
  return api().get(`/api/users/ojti/${atcu}`);
};
